import { persist, get, post, patch, del, push } from '@/assets/js/util.js'

const data = {
    search: '',
    sortBy: '-created',
    type: '',
    filteredItems: [],
    items: [],
    inventoryItems: [],
    cart: []
}
const context = persist('commerce', data)
export default context
